<template>
  <div class="relation">
    <vxe-table
      border
      show-overflow
      resizable
      :auto-resize="true"
      ref="xTable"
      class="vxe-table-element"
      size="mini"
      :data="tableData"
      @cell-dblclick="dblclickEvent"
      :edit-config="{}"
    >
      <vxe-table-column type="seq" width="80" title="序号"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :type="item.type"
        :key="index"
        :fixed="item.fixed"
        :field="item.prop"
        :title="item.label"
        :width="item.width"
        :sortable="item.sortable"
        :edit-render="item.editRender"
      >
        <template v-slot="{ row }">
          <template v-if="item.prop === 'contractType'">{{
            translateContractType(row.contractType)
          }}</template>
          <template v-else>{{ row[item.prop] }}</template>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  export default {
    name: 'RelationContractTable',
    props: {
      contractNo: {
        type: String,
        default: '',
      },

      contractStatus: {
        type: String,
        default: '',
      },
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        tableData: [],
        editConfig: {},
        contractTypeList: [], // 合同类型
      };
    },
    computed: {
      // 表格展示数据
      columnList() {
        return [
          {
            prop: 'originalContractNo',
            label: '编号',
          },
          {
            prop: 'contractType',
            label: '合同类型',
          },
          {
            prop: 'storageName',
            label: '仓库信息',
          },
          {
            prop: 'gmtCreate',
            label: '制单日期',
          },
          {
            prop: 'contractValidFrom',
            label: '起始时间',
          },
          {
            prop: 'contractValidUntil',
            label: '结束时间',
          },
          {
            prop: 'remark',
            label: '备注',
          },
        ];
      },
    },
    mounted() {
      this.contractTypeList = this.dictListMap.SuperviseContractType;
    },
    methods: {
      translateContractType(type) {
        return this.contractTypeList.find((item) => item.value == type)?.label;
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.xTable;
        return $table.getTableData().fullData;
      },
      // 双击行
      dblclickEvent({ row }) {
        console.log(row);
      },
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            console.log(val, '监听');
            this.tableData = val;
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .vxe-table-element {
    margin-top: 5px;
  }

  .relation {
    margin-bottom: 10px;
  }
</style>
